<template>
  <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modalgenerar">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"><b>Obtener enlace de Pre Inscripcion</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <div v-if="unidad && unidad.nombre" class="text-left">
            <v-row no-gutters>
              <v-col cols="12" sm="6">
                <p class="mb-0"><b>Unidad:</b> {{ unidad.nombre }}</p>
                <p class="mb-0"><b>Unidad Codigo:</b> {{ unidad.codigo }}</p>
              </v-col>
              <v-col cols="12" sm="6">
                <p class="mb-0"><b>Unidad Correo:</b> {{ unidad.email }}</p>
                <p class="mb-0"><b>Unidad Sitio Web:</b> {{ unidad.sitio_web }}</p>
              </v-col>
            </v-row>
          </div>

          <div>
            <div id="aquivaelqr"></div>
          </div>

          <p>
            Usa el siguiente enlace para compartirlo con tus contactos. <br /><br />
            <b>Recuerda que:</b> Este enlace es unico y te identifica a ti como asesor para todos aquellos que usen el
            enlace y se pre inscriban a: <br />
            <b> {{ programa.nombre_compuesto }} </b>
          </p>
          <v-progress-linear indeterminate v-if="loading_negocio" />

          <div v-if="unidad.sitio_web">
            <div>
              <input
                type="text"
                class="info--text text-center xput"
                editable="false"
                ref="inputenlace"
                v-model="enlace"
                style="font-size: 1.3em" />
            </div>
            <div v-if="enlace2" style="font-size: 0.9em">
              <p class="mt-8 mb-0"> Enlace para programas en bolivia, este link no filtra las universidades muestra todas las instituciones. </p>
              <input
                type="text"
                class="info--text text-center xput mb-4"
                editable="false" 
                v-model="enlace2"
                style="font-size: 1.1em" />
            </div>
            <p v-if="copiado" class="mb-0 green--text">
              <small>Enlace copiado al portapapeles.</small>
            </p>
            <button class="btn btn-azul btn-sm" :disabled="loading_negocio" @click="copytext()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-clipboard-check"
                viewBox="0 0 16 16">
                <path
                  fill-rule="evenodd"
                  d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
              Copiar enlace
            </button>
            <button class="btn btn-azul btn-sm ml-1 pt-2" :disabled="loading_negocio" @click="descargarqr()">
              <span class="glyphicon glyphicon-qrcode"></span>
              descargar QR
            </button>
          </div>
          <div v-else>
            <p v-if="!loading_negocio" class="mb-0 red--text text-center">
              No se pudo generar enlace de preinscripcion debido a que la unidad de negocio {{ unidad.nombre }} no tiene
              sitio web asignado en la base de datos del portal.
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .xput:focus {
    outline: none !important;
  }
  .xput {
    font-size: bold;
    width: 100%;
    border: 0!;
  }
  #aquivaelqr > img {
    width: 100px !important;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  export default {
    props: { obj: { type: Object, required: false } },
    data() {
      return {
        activo: true,
        copiado: false,
        programa: {},
        token: '',
        enlace: process.env.VUE_APP_DOMAIN + 'registro/slug-generado-automaticamente',
        enlace2: '',
        loading_negocio: false,
        unidad: {},
      };
    },
    watch: {},
    components: {},
    methods: {
      async copytext() {
        await navigator.clipboard.writeText(this.enlace)

        window.console.log(this.obj);
        let input = this.$refs['inputenlace'];
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        this.copiado = true;
      },
      open(programa) { 
        // window.console.log('programa',programa);
        this.enlace2 = ''
        
        if(programa.fase == 0 ){
          this.$root.$notify.show(`El programa no esta aprobado.`, {color:'red',x: 'right',});
          return;
        }
        
        this.programa = programa;
        window.$('#modalgenerar').modal('show');
        this.getunidadnegocio();
        //this.generartoken();
      },
      async getunidadnegocio() {
        this.loading_negocio = true;
        let unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
        if(this.programa.unidad_negocio){
          unidad_negocio = this.programa.unidad_negocio
        }
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadnegocio`;
        let res = await xaxios
          .get(url)
          .then(({ data }) => data)
          .catch((e) => e);
        window.console.log('res unidad negocio', res);
        
        this.unidad = res.find((x) => x.id == unidad_negocio);
        if(!this.unidad.sitio_web) this.unidad.sitio_web = 'https://esam.edu.bo';
        this.generartoken();
        this.loading_negocio = false;
      },
      generartoken() {
        window.console.log('this.programa',this.programa);
        
        let a1 = 'A';
        let a2 = 'B';
        let a3 = 'C';
        let a4 = 'D';
        let a5 = 'E';
        let a6 = 'F';
        let a7 = 'G';
        let a8 = 'H';
        let a9 = 'I';
        let a0 = 'J';
        let iduser = this.$store.state.DATA_USER.id;
        let tok = this.programa.id + '-' + iduser;
        tok = tok.replace(/1/g, a1);
        tok = tok.replace(/2/g, a2);
        tok = tok.replace(/3/g, a3);
        tok = tok.replace(/4/g, a4);
        tok = tok.replace(/5/g, a5);
        tok = tok.replace(/6/g, a6);
        tok = tok.replace(/7/g, a7);
        tok = tok.replace(/8/g, a8);
        tok = tok.replace(/9/g, a9);
        tok = tok.replace(/0/g, a0);
        //this.enlace = process.env.VUE_APP_DOMAIN + 'registro?t=' + tok;
        this.enlace = this.unidad.sitio_web + '/registro?t=' + tok;
        this.enlace = this.enlace.replaceAll('//r','/r');
        // window.console.log('>>>',this.unidad);

        if(this.programa.universidad && this.programa.universidad.nombre=='Universidad Politécnica Internacional'){
          this.unidad.id = 15 // upi
          // window.alert('jejeje')
        }

        if(this.unidad.id == 5){
          this.enlace = `https://formulario.esamlatam.com/registro?t=${tok}`
        }
        if(this.unidad.id == 14){
          this.enlace = `https://formulario.ispi.edu.pa?t=${tok}`
        }

        if(this.unidad.id == 15){ // upi 
          const codereg = `${this.programa.id}-${iduser}-p`
          const code = this.codificarBase64(codereg)
          /* this.enlace = `https://upi.edu.pa/portal/upi/${code}/registro.html` 
          this.enlace2 = `https://upi.edu.pa/portal/upi/${code}/registro.html?filterins=0`  */
          this.enlace = `https://formulario.upi.edu.pa/${code}/registro.html` 
          this.enlace2 = `https://formulario.upi.edu.pa/${code}/registro.html?filterins=0` 
        }
        
        this.crearqrenlace();
      },
      crearqrenlace() {
        let imglogo = 'img/logo_esam_factura.png';
        if (this.unidad.id == 10) imglogo = 'img/dbslogob.png';
        var options = {
          text: this.enlace,
          width: 720,
          height: 720,
          logo: imglogo,
          logoBackgroundTransparent: true,
          quietZone: 4,
          version: 0,
          dotScale: 1,
          correctLevel: window.QRCode.CorrectLevel.Q,
          onRenderingEnd: this.renderingEnd(),
        };

        var element = document.getElementById('aquivaelqr');
        element.innerHTML = '';
        new window.QRCode(element, options);
        //window.$("img", "#aquivaelqr").attr("width", "150px"); // qrcode v3
        window.$('canvas', '#aquivaelqr').css('width', '150px');
      },
      descargarqr() {
        /*let p = this.programa.nombre_compuesto;
            let a = this.$store.state.DATA_USER.nombres;
            var save = document.createElement("a");
            save.href = window.$("img", "#aquivaelqr").attr("src");
            save.target = "_blank";
            save.download = "QR-" + a + "-" + p + ".jpg";
            save.click(); qrcode v3*/

        let p = this.programa.nombre_compuesto;
        let a = this.$store.state.DATA_USER.nombres;
        var save = document.createElement('a');
        let div = document.getElementById('aquivaelqr');
        var canvas = div.querySelector('canvas');
        var image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        save.href = image;
        save.target = '_blank';
        save.download = 'QR-' + a + '-' + p + '.jpg';
        save.click();
      },
      /* eslint-disable @typescript-eslint/no-explicit-any */
      codificarBase64(texto){
        return btoa(texto) // btoa: binary to ASCII
      },
      renderingEnd() {},
      submit() {},
    },
    mounted() {
      const vue = this;
      window.$('#modalgenerar').on('hidden.bs.modal', function () {
        vue.copiado = false;
        vue.activo = true;
      });
    },
  };
</script>
